import type { FaireProductEntity } from "../../entity_types/product";

export const p_p7twxvnm6j: FaireProductEntity = {
  token: "p_p7twxvnm6j",
  type: "product",
  name: "Globetrotter Quilted Nylon Puffer Travel Weekender",
  brandToken: "b_7yc0xhlyll",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/96af9a49b5d54e8db9f19752ecf827d8bb601522a799020629ad99c6a7ae4f9a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b30d33a1d5f051bed199f762860f315363e44a1b318bafce80a07e41b16849b.jpeg",
    "https://cdn.faire.com/fastly/2993ee7debfdb4a9f589ec50043079d64353ec58b1c6243d873cf82bd1e0dc65.jpeg",
    "https://cdn.faire.com/fastly/3e44a68e81782efc5c1c5952710b59c6061983d95c0f6101ecab1ca6d59b9ecb.jpeg",
    "https://cdn.faire.com/fastly/5874d766cc7cff036dab0d271f4513fbb2566d5a48ad4a4abff589fa7b8e01b3.jpeg",
    "https://cdn.faire.com/fastly/4b4c36770326f93852752b40249e39178d698f7a70d1a8b62a37e0022dc8010f.jpeg",
    "https://cdn.faire.com/fastly/312c76ed44df3500d8cdad6ad533694f6c6b1eea785f76dbc0193848cea7f4ff.jpeg",
    "https://cdn.faire.com/fastly/5cddd3be0f1f5684fe18d0aa7942f62dcbd15e5f249937cf4ec731f4851b5fb9.jpeg",
    "https://cdn.faire.com/fastly/d3eac072f81cd1e0fded4967b17cc6479446006bf6b67b7813eb26bb3f49e1a5.jpeg",
    "https://cdn.faire.com/fastly/4a3e8cda60e96566440ec59084852a023ec9a43ac4b1a163b6b7a3cb9a36c92a.jpeg",
    "https://cdn.faire.com/fastly/2a4e51455865f2dbee8c2e8e9a32069951bd72e182c3a9113ff84996c4e0681b.jpeg",
    "https://cdn.faire.com/fastly/bd035ae4c967afd6f416aefeac9d58d6997a79bd9649c023c0a4c56852f1467d.jpeg",
    "https://cdn.faire.com/fastly/163f75ce20891cd1b5b9f80a59944a0a9babd6f615153df802f80ea783da5ff7.jpeg",
    "https://cdn.faire.com/fastly/07c5795187dfdd3eac88795f9641123e75e1fdaee9b2b4b41af3cf9b7a866161.jpeg",
    "https://cdn.faire.com/fastly/9513a3bea4a993c2cdfc675e04ac0a17ef7fde7cb06e92af7cf1ca6023851811.jpeg",
    "https://cdn.faire.com/fastly/091e79137c20de191b355dd082fc475dd39e8ef7de4cfff7eb49b585616dee8d.jpeg",
    "https://cdn.faire.com/fastly/1b3d6c28da83fa091c5f84f7f39349d1b370c71dc02470fdfd1419eac7b90828.jpeg",
    "https://cdn.faire.com/fastly/57a56796a7ad195b1bbec915da24391088c0f7ce94169669c58e4292236366d0.jpeg",
    "https://cdn.faire.com/fastly/08704ea4513eb2d0042d41402dda3bf08ad92d9697fa3dbe5dd164374751797f.jpeg",
    "https://cdn.faire.com/fastly/7d03182096399eeeffa6be74ac9b197ab286ab15748d254756e6351c2acf63f9.jpeg",
    "https://cdn.faire.com/fastly/d3c4310b19d85636ae402b248f45ef0614e23cb56859611351f44c1018cc27b5.jpeg",
    "https://cdn.faire.com/fastly/5e07bfbd0b7b3c6f0d11337b9dabb42c2861e303362132d666c84e69a23c7fd3.jpeg",
    "https://cdn.faire.com/fastly/23a86cfb168d0bb305a68e06a721768da6e3aa6adce16ed37a355c3131f06fa2.jpeg",
    "https://cdn.faire.com/fastly/78c8632942b7444f5093897e5f5d18643046a1ba0a8ff054ba4b8636bce1421b.jpeg",
  ],
  priceDollars: 83.14,
  description:
    "Unleash your wanderlust with the Globetrotter Weekender. Designed for the modern woman on the go, this chic bag combines effortless style with practical functionality. \n\nFeaturing a spacious interior, zip pockets, and durable vegan materials, it’s your perfect travel companion. Whether you’re heading to the gym, a weekend getaway, or a busy day at work, this bag transitions seamlessly from one occasion to another. \n\nWith its contemporary quilted design and comfortable handles, you can carry your essentials with elegance. Elevate your travel game today—this bag is a must-have for every stylish adventurer.\n\n*Item Type: Weekender\n*Material: Nylon\n*Closure: Zipper\n*Exterior Details: Adjustable/Detachable Shoulder Strap, Trolly Sleeve, Silver Hardware, Bottom Zip Compartment, Tassel Ties, Quilted Design\n*Interior Details: Nylon Fabric Lined, 1 Zip Mesh Pocket, 3 Slip Pockets",
  tags: [],
  msrpDollars: 166.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:13.130Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
